import * as types from '../mutation-types';
import PagesService from '~/services/pages';

const baseControl = {
  url: '/admin',
  label: 'Панель управления',
  roles: ['admin', 'curator']
};

// state
export const state = {
  pagesInfo: window.config.pagesInfo ? window.config.pagesInfo : [],
  breadcrumbs: [],
  page: {},
  controls: [
    baseControl
  ],
  loading: false,
  pageInfo: null,
  currentPageTitle: 'Главная'
};

// getters
export const getters = {
  pageInfo: state => state.pageInfo,
  pagesInfo: state => state.pagesInfo,
  page: state => state.page,
  loading: state => state.loading,
  getPageInfo: state => type => {
    const page = state.pagesInfo.find(p => p.name === type) || {};
    state.page = page || {};

    return page || {};
  },
  breadcrumbs: state => state.breadcrumbs,
  controls: state => state.controls,
  currentPageTitle: state => state.currentPageTitle,
};

// mutations
export const mutations = {
  [types.PAGES_FIND] (state, page) {
    state.page = page;
  },
  [types.PAGE_SELECTED] (state, pageInfo) {
    state.pageInfo = pageInfo;
  },
  [types.PAGE_CLEAR] (state) {
    state.page = {};
  },
  [types.PAGES_SET_BREADCRUMBS] (state, breadcrumbs) {
    if (breadcrumbs.length > 0) {
      state.breadcrumbs = breadcrumbs.slice(0, breadcrumbs.length - 1);
      state.currentPageTitle = breadcrumbs[breadcrumbs.length - 1];
    } else {
      state.breadcrumbs = [];
      state.currentPageTitle = 'Главная';
    }
  },
  [types.PAGES_SET_CONTROLS] (state, controls) {
    state.controls = [
      baseControl
    ];
    controls.forEach(c => {
      state.controls.push(c)
    });
  },
  [types.PAGES_UPDATE] (state, page) {
    state.page = page;
  },
  [types.LOADING_START] (state) {
    state.loading = true;
  },
  [types.LOADING_STOP] (state) {
    state.loading = false;
  },
};

// actions
export const actions = {
  async find ({ commit }, type) {
    const page = await PagesService.getPage(type);
    commit(types.PAGES_FIND, page);
  },
  setBreadcrumbs ({ commit }, breadcrumbs) {
    commit(types.PAGES_SET_BREADCRUMBS, breadcrumbs);
  },
  setControls ({ commit }, controls) {
    commit(types.PAGES_SET_CONTROLS, controls);
  },
  updatePage ({ commit }, page) {
    commit(types.PAGES_UPDATE, page);
  },
  clearPage ({ commit }) {
    commit(types.PAGE_CLEAR);
  },
  startLoading ({ commit }) {
    commit(types.LOADING_START);
  },
  stopLoading ({ commit }) {
    commit(types.LOADING_STOP);
  },
  selectPage ({ commit }, pageInfo) {
    commit(types.PAGE_SELECTED, pageInfo);
  }
};
